var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dynamic-toolbar',{attrs:{"show-full-toolbar":_vm.$vuetify.breakpoint.mdAndUp,"dense":"","flat":"","menu-items":_vm.menuItems}})}
var staticRenderFns = []

export { render, staticRenderFns }